import {Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation} from '@angular/core';
import {WorkflowService} from '../../../../services/apiServices/business/workflow-service';
import {SelectItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {UserManagementService} from '../../../../services/apiServices/business/user-management.service';
import {CustomerGroup} from '../../../../model/customer-group';
import {TreatmentChainService} from '../../../../services/apiServices/business/treatment-chain.service';
import {EmailValidator} from '../../../../model/email-validator';
import {Dropdown} from 'primeng/dropdown';
import {AuthenticationService} from '../../../../services/apiServices/security/authentication.service';
import {User} from '../../../../model/user';
import {Table} from 'primeng/table';
import {CommonService} from '../../../../services/apiServices/business/common.service';

// noinspection JSUnusedLocalSymbols
/**
 * Component represented by signature and validation modal
 */
@Component({
  selector: 'app-group-management',
  templateUrl: './group-management.component.html',
  styleUrls: ['./group-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupManagementComponent implements OnInit {
  @ViewChild('sGrpUserID', { static: false } )
  sGrpUserID: ElementRef;
  @ViewChild('sGrpUserLabel', { static: false } )
  sGrpUserLabel: ElementRef;
  @ViewChild('sAlarmeEmail', { static: false } )
  sAlarmeEmail: ElementRef;
  @ViewChild('sCustomerGrpEmail', { static: false } )
  sCustomerGrpEmail: ElementRef;
  @ViewChild('sLangId', { static: false } )
  sLangId: Dropdown;
  groupList: CustomerGroup[];
  selectedGroup: CustomerGroup;
  editGroup: CustomerGroup;
  pageRows: number;
  groupColumns: any[];
  groupSortField: string;
  addressObj: any;
  editGroupAddress: boolean;
  groupIdColumnLabel: string;
  duplicateIdLabel: string;
  groupNameColumnLabel: string;
  showLockFailureMessage: boolean;
  newGroup: boolean;
  trtChainList: any[];
  duplicateId: boolean;
  showImportUsers: boolean;
  showGroupChains: boolean;
  locales: SelectItem [];
  languages: any;
  currentUser: User;

  /*
  * constructor that instantiate variables
  *
  * @param {WorkflowService} workflowService - permit httpRequest correctly formatted
  * @param {CommonService} commonService - handle displaying message
  * @param {TranslateService} translate - handle component translation
  */
  constructor(private renderer: Renderer2, private workflowService: WorkflowService, private commonService: CommonService,
              private userManagementService: UserManagementService, private translate: TranslateService,
              private trtChainService: TreatmentChainService, private authService: AuthenticationService ) {
    this.pageRows = 10;
    this.groupColumns = [];

  }

  /**
   * Affect variables
   */
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.fillTreatmentChains();
    this.showGroupChains = false;
    this.showImportUsers = false;
    this.newGroup = false;
    this.editGroupAddress = false;
    this.showLockFailureMessage = false;
    this.getTradForComponent();
    this.buildColumns();

    this.getCustomerGroups();

    this.userManagementService.groupAddressEvent.subscribe(address => {
      this.addressObj = {
        address : address ? address : {}
      };
    });
  }

  public getCustomerGroups(): void {
    this.userManagementService.getCustomerGroups().subscribe(res => {
      this.groupList = [];
      for (const gr of res.listObjOrgGrpUser) {
        if (this.currentUser.idUser.toUpperCase() === 'adminNumen'.toUpperCase()) {
          this.groupList.push(gr);
        }
        else {
          if (gr.sGrpUserID
            && gr.sGrpUserID.toUpperCase() !== 'adminapp'.toUpperCase()
            && gr.sGrpUserID.toUpperCase() !== 'support'.toUpperCase()
            && gr.sGrpUserID.toUpperCase() !== 'deposit'.toUpperCase()) {
            this.groupList.push(gr);
          }
        }
      }
      this.groupList = this.groupList.map(gr => {
        const users = gr.objOrgUserList.datas ?? [];

        const userIds = users
          .map(u => u.sUserID)
          .join(' ')
          .toLowerCase();

        return {
          ...gr,
          filterContent: `${gr.sGrpUserLabel} ${gr.sGrpUserID} ${userIds}`.toLowerCase()
        };
      });

    });
  }

  public handleAddressClose(result: boolean): void {
    this.editGroupAddress = result;
  }
  public editAddress(): void {
    this.addressObj['addInfo'] = {
      'sCountryID': this.addressObj.address.COUNTRY,
      sElem: [
        this.addressObj.address.RECIPIENT,
        this.addressObj.address.APARTMENT,
        this.addressObj.address.BUILDING,
        this.addressObj.address.STREET,
        this.addressObj.address.SERVICE,
        this.addressObj.address.POSTAL_CODE,
        '',
        this.addressObj.address.CITY,
        this.addressObj.address.COUNTRY,
      ],
      'mElemByName': {
        'addrElem1': this.addressObj.address.RECIPIENT,
        'addrElem2': this.addressObj.address.APARTMENT,
        'addrElem3': this.addressObj.address.BUILDING,
        'addrElem4': this.addressObj.address.STREET,
        'addrElem5': this.addressObj.address.SERVICE,
        'addrElem7': '',
        'city': this.addressObj.address.CITY,
        'country': this.addressObj.address.COUNTRY,
        'zipcode': this.addressObj.address.POSTAL_CODE
      },
    };
    this.editGroupAddress = true;
  }
  public buildColumns(): void {
    this.groupSortField = 'sGrpUserID';
    this.groupColumns.push({field: 'sGrpUserID', header: this.groupIdColumnLabel});
    this.groupColumns.push({field: 'sGrpUserLabel', header: this.groupNameColumnLabel});
    // this.groupColumns.push({field: 'sCustomerGrpEmail', header: this.groupEmailColumnLabel});
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.languages = {
      'en_US': this.translate.instant('COMMON.LANGUAGES.LANG_EN'),
      'fr_FR': this.translate.instant('COMMON.LANGUAGES.LANG_FR')
    };
    this.locales = [
      {label: '', value: ''},
      {label: this.translate.instant('COMMON.LANGUAGES.LANG_FR'), value: 'fr_FR'},
      {label: this.translate.instant('COMMON.LANGUAGES.LANG_EN'), value: 'en_US'}
    ];
    this.groupIdColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.GROUP_ID_LABEL');
    this.groupNameColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.GROUP_NAME_LABEL');
    this.duplicateIdLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.DUPLICATE_ID_LABEL');
  }

  private fillTreatmentChains(): void {
    this.trtChainList = [];
    this.trtChainList.push({
      label: this.trtChainService.defaultTreatmentChain,
      value: this.trtChainService.defaultTreatmentChain
    });

    for (const treatmentChain of this.trtChainService.getTreatmentChainList()) {
      this.trtChainList.push({label: treatmentChain.sTrtChainName, value: treatmentChain.sTrtChainName});
    }

  }

  public handleGroupSelection(selected: any ) {
    if (this.selectedGroup && this.selectedGroup.sGrpUserID === selected.sGrpUserID) {
      this.selectedGroup = null;
      this.newGroup = false;
    } else {
      this.selectedGroup = selected;
      this.editGroup = null;
      this.newGroup = false;
      this.userManagementService.selectGroup(this.selectedGroup);
    }
  }

  public editSelectedGroup(): void {
    this.userManagementService.lockCustomerForGroupEdition().subscribe(resposne => {
      if (resposne['bOK'] && resposne['bOK'] === true) {
        this.editGroup = this.selectedGroup;
        this.newGroup = false;
        this.showLockFailureMessage = false;
      } else {
        this.showLockFailureMessage = true;
      }
    });
  }

  public createNewGroup(): void {
    this.editGroup = new CustomerGroup();
    this.editGroup.bGrpUserActive = true;
    this.editGroup.sLangId = 'fr_FR';
    this.editGroup.sLevelIdParent = 'NONE';
    this.editGroup.pathParent = 'NONE';
    this.selectedGroup = this.editGroup;
    this.newGroup = true;
    this.showLockFailureMessage = false;
  }

  public cancelEditGroup(): void {
    this.editGroup = null;
    this.newGroup = false;
  }

  validateElement(el: ElementRef, valid: boolean): boolean {

    if (valid) {
      this.renderer.removeClass(el.nativeElement, 'invalid');
      this.renderer.addClass(el.nativeElement, 'valid');
      return true;
    } else {
      this.renderer.removeClass(el.nativeElement, 'valid');
      this.renderer.addClass(el.nativeElement, 'invalid');
      return false;
    }
  }
  validateElementDD(dd: Dropdown, valid: boolean): boolean {
    if (valid) {
      this.renderer.removeClass(dd.el.nativeElement, 'invalid-dd');
      this.renderer.addClass(dd.el.nativeElement, 'valid-dd');
      return true;
    } else {
      this.renderer.removeClass(dd.el.nativeElement, 'valid-dd');
      this.renderer.addClass(dd.el.nativeElement, 'invalid-dd');
      return false;
    }
  }
  public isAvaliableId(id: string): boolean {
    for (const group of this.groupList) {
      if (group.sGrpUserID === id) {
        return false;
      }
    }
    return true;
  }
  public validate() {
    let v1 = true;
    if (this.newGroup) {
      v1 = (this.editGroup.sGrpUserID && this.editGroup.sGrpUserID !== '');
      if (v1) {
        const available = this.isAvaliableId(this.editGroup.sGrpUserID);
        this.duplicateId =  !available;
        v1 = available;
      }
      this.validateElement(this.sGrpUserID, v1);
    }

    const v2 = this.validateElement(this.sGrpUserLabel, (this.editGroup.sGrpUserLabel && this.editGroup.sGrpUserLabel !== ''));
    const v3 = this.validateElement(this.sAlarmeEmail, EmailValidator.emailIsValid(this.editGroup.sAlarmeEmail));
    const v4 = this.validateElement(this.sCustomerGrpEmail, EmailValidator.emailIsValid(this.editGroup.sCustomerGrpEmail));
    const v5 = this.validateElementDD(this.sLangId, (this.editGroup.sLangId && this.editGroup.sLangId !== ''));
    return v1 && v2 && v3 && v4 && v5;
  }

  public saveGroup(): void {
    if (this.validate()) {
      if (this.newGroup) {
        this.userManagementService.createGroup(this.editGroup).subscribe(response => {
          this.editGroup = null;
          this.getCustomerGroups();
        });
      } else {
        this.userManagementService.updateGroup(this.editGroup).subscribe(response => {
          this.editGroup = null;
        });
      }
    }
  }

  showImportUsersModal() {
    this.showImportUsers = true;
  }
  showGroupChainModal() {
    this.showGroupChains = true;
  }

  handleConfigSaved(event) {
    this.showGroupChains = false;
  }

  clear(groupMgmListGrp: Table) {
    groupMgmListGrp.clear();
  }

  protected readonly HTMLTextAreaElement = HTMLTextAreaElement;
  protected readonly HTMLInputElement = HTMLInputElement;

  filter(groupMgmListGrp: Table, target: EventTarget) {
    groupMgmListGrp.filterGlobal((target as HTMLInputElement).value, 'contains');
  }
}
